import React from "react";
import styled from "styled-components";
import { AuthContext } from "context/Auth";
import { useHistory } from "react-router-dom";
import searchIcon from "assets/img/search.svg";
import UserAvatar from "react-user-avatar";
import { SearchContext } from "context/Search";
import "assets/css/header.css";

const DropDown = styled.ul`
  z-index: 2222222;
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px rgba(242, 48, 80, 0.1) solid;
  border-radius: 8px;
  border-bottom: none;
  box-shadow: 0px 5px 5px rgba(242, 48, 80, 0.3);
  width: 170px;
  transform: translateY(-900em);
  opacity: 0;
  border-top: 10px solid rgba(255, 255, 255, 0);
  right: 2px;

  @media (max-width: 550px) {
    right: -15px;
  }

  li {
    display: flex;
    flex-direction: row;
    padding: 10px 15px;
    border-bottom: 1px solid rgba(105, 196, 72, 0.2);

    a {
      color: $gs3-secondary;
      background: #fff;
      padding: 10px;
      text-align: center;
      transition: background-color ease-in-out 0.2s;
    }

    &:hover {
      background-color: rgba(105, 196, 72, 0.2);
    }
  }
`;

const DropDownWrapper = styled.div`
  position: relative;

  img {
    cursor: pointer;
  }

  &:hover > ul,
  & > ul:hover {
    animation: profileSideDropDown 0.2s linear forwards;
  }

  @keyframes profileSideDropDown {
    0% {
      transform: translateY(0em);
      top: 0px;
      opacity: 0;
    }

    100% {
      opacity: 1;
      transform: translateY(0.9em);
      top: 40px;
    }
  }
`;

function runSearch(history, tab, search) {
  history.push(`/search?q=${search}&tab=${tab}`);
}

export default function Header(/*{openSidebar}*/) {
  const history = useHistory();
  const query = new URLSearchParams(history.location.search).get("q");
  const { me, meQuery } = React.useContext(AuthContext);
  const { tab, setQuery, setTab } = React.useContext(SearchContext);
  const [search, setSearch] = React.useState(query || "");

  React.useEffect(() => meQuery(), []);

  return (
    <nav>
      <div className="inner-container">
        <div id="nav-items" style={{ display: "flex" }}>
          <form className="desktop-only" onSubmit={(e) => e.preventDefault()}>
            <div className="input">
              <input
                type="text"
                name="search"
                id="search"
                placeholder="Search..."
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter" && search) {
                    runSearch(history, tab, search);
                  }
                }}
                value={search}
              />
              <img
                src={searchIcon}
                alt="searchIcon"
                className="search-icon"
                onClick={() => {
                  if (search) runSearch(history, tab, search);
                }}
              />
            </div>
            {history?.location?.pathname === "/search" && (
              <div id="search-suggestion-box">
                <div
                  onClick={() => {
                    setTab("cases");
                    setQuery(search);
                    history.push(`/search?q=${search}&tab=cases`);
                  }}
                  className="search-suggestion"
                >
                  <p>Case</p>
                </div>

                <div
                  onClick={() => {
                    if (search) {
                      setTab("dictionary");
                      setQuery(search);
                      history.push(`/search?q=${search}&tab=dictionary`);
                    }
                  }}
                  className="search-suggestion"
                >
                  <p>Dictionary</p>
                </div>
              </div>
            )}
          </form>
          <div id="right-nav-items" style={{ marginLeft: "auto" }}>
            <div id="profile" style={{ display: "flex", alignItems: "center" }}>
              <React.Fragment>
                <UserAvatar
                  size="40"
                  style={{
                    color: "white",
                    fontWeight: "400",
                    userSelect: "none",
                    marginRight: "5px",
                    border: "8px solid #ffebf4",
                    borderRadius: "50%",
                  }}
                  name={
                    me?.first_name
                      ? `${me?.first_name} ${me?.last_name}`
                      : "Administrator"
                  }
                  src={me?.profile_pic}
                />
              </React.Fragment>

              <div className="text">
                <p>
                  {me?.first_name} {me?.last_name}
                </p>
                <p>Administrator</p>
              </div>
            </div>
          </div>
        </div>
        {/*MOBILE TABS*/}
        <form className="mobile-only">
          <div className="input">
            <input
              type="text"
              name="search"
              id="search"
              placeholder="search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              onKeyUp={(e) => {
                if (e.key === "Enter" && search) {
                  runSearch(history, setTab, setQuery, tab, search);
                }
              }}
              value={search}
            />
          </div>
          {history?.location?.pathname === "/search" && (
            <div id="search-suggestion-box">
              <div className="search-suggestion">
                <p>Case</p>
              </div>
              <div className="search-suggestion">
                <p>Civil Procedure Rules</p>
              </div>
              <div className="search-suggestion">
                <p>Laws of the Fed</p>
              </div>
            </div>
          )}
        </form>
      </div>
    </nav>
  );
}
